import { gql } from "@apollo/client";

export const DESESTIMAR_LIQUIDACION = gql`
    mutation rechazarLiquidacionFinal($idLiquidacionProfesional: [Int!]!, $justificacion: String!) {
        rechazarLiquidacionFinal(idLiquidacionProfesional: $idLiquidacionProfesional, justificacion: $justificacion)
    }
`;